import CodeChip from "@components/code-chip";
import MediaAssetMetaUpdate from "../asset/MediaAssetMetaUpdate";
import { useState } from "react";

type AudioCardProp = {
  selectedAudio: {
    id: string;
    code: string;
    translation: string;
    language: string;
    localText: string;
    url: string;
  };

  IsAudioSelected: boolean;
  onAudioChange: (val: boolean) => void;
};

function AudioListCard({
  IsAudioSelected,
  selectedAudio,
  onAudioChange,
}: AudioCardProp) {
  const { id, language, code, localText, translation, url } = selectedAudio;

  const removeMp3Extension = (filename: string): string =>
    filename.endsWith(".mp3") ? filename.slice(0, -4) : filename;

  const [isOpen, setClose] = useState<boolean>(false);

  const handlOpenEditingModal = (val: boolean) => {
    setClose(val);
  };

  return (
    <>
      <article className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 p-4 flex flex-col justify-between h-64">
        <div className="mb-3">
          <CodeChip code={removeMp3Extension(code)} />
        </div>

        <audio controls className="w-full rounded">
          <source src={url} type="audio/mp3" />
          Your browser does not support the audio element.
        </audio>

        <div className="text-sm mt-3">
          <p className="font-medium text-gray-800 line-clamp-1">{localText}</p>
          <p className="text-gray-500 line-clamp-1">{translation}</p>
        </div>

        <button
          onClick={() => onAudioChange(!IsAudioSelected)}
          className={`mt-3 text-sm px-3 py-1 rounded transition ${
            IsAudioSelected ? "bg-gray-400 text-white" : "bg-brand text-white"
          }`}
        >
          {IsAudioSelected ? "Hide Details" : "View Details"}
        </button>
      </article>

      {IsAudioSelected && (
        <aside className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg p-6 z-50 overflow-y-auto">
          <button
            onClick={() => onAudioChange(false)}
            className="text-sm font-semibold text-black hover:text-gray-700 mb-4"
          >
            Close
          </button>

          <h2 className="text-xl font-semibold mb-4">Audio Details</h2>

          <audio controls className="w-full mb-4">
            <source src={url} type="audio/mp3" />
          </audio>

          <p className="mb-2">
            <span className="font-semibold">Code:</span>{" "}
            {removeMp3Extension(code)}
          </p>
          <p className="mb-2">
            <span className="font-semibold">Language:</span> {language}
          </p>
          <p className="mb-2">
            <span className="font-semibold">Local Text:</span> {localText}
          </p>
          <p className="mb-4">
            <span className="font-semibold">Translation:</span> {translation}
          </p>

          <button
            className="px-4 py-2 bg-brand text-white rounded-md hover:bg-[#6ea1e9]"
            onClick={() => handlOpenEditingModal(true)}
          >
            Edit Audio
          </button>
        </aside>
      )}

      {isOpen && (
        <MediaAssetMetaUpdate
          assetToUpdate={{
            localText,
            translation,
            id,
          }}
          assetTypeToUpdate="Audio"
          setIsModalOpen={(val) => handlOpenEditingModal(val)}
        />
      )}
    </>
  );
}

export default AudioListCard;
